import { di } from 'react-magnetic-di';

type BuildReferenceUpdate = {
	buildId: string;
	state: 'SUCCESS';
	objectAri?: string;
};

export async function updateBuildState(
	workspaceId: string,
	{ buildId, state, objectAri }: BuildReferenceUpdate,
): Promise<void> {
	di(fetch);

	const response = await fetch(
		`/gateway/studio/workspace/${workspaceId}/api/studio/solution-architect/build-reference`,
		{
			method: 'POST',
			credentials: 'include',
			body: JSON.stringify({
				buildId,
				updates: {
					state,
					ari: objectAri,
				},
			}),
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);

	if (!response.ok) {
		throw new Error('Failed to update build state.');
	}
}
